
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28725",
  depVersions: {
  "payments-ui-app": "static-1.28725",
  "bend-plugin-arboretum": "static-1.2029",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.511",
  "crm_data": "static-4.93228",
  "data-fetching-client": "static-1.10124",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8765",
  "foundations-components-legacy": "static-1.1790",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6077",
  "hs-test-utils": "static-1.8524",
  "hub-http": "static-1.6691",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11972",
  "I18n": "static-7.1709",
  "jasmine-runner": "static-1.6938",
  "quartz": "static-1.7680",
  "raven": "static-3.5925",
  "react-dlb": "static-1.94",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.121",
  "react-utils": "static-2.5664",
  "reselect": "static-3.16",
  "stripe-js": "static-1.120",
  "ui-components-test-utils": "static-1.6109",
  "UIComponents": "static-3.8918",
  "usage-tracker-public": "static-1.7619",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38076",
  "payments-checkout-lib": "static-1.648",
  "cssUtils": "static-1.1108",
  "customer-data-objects": "static-1.8192",
  "FireAlarmUi": "static-1.4875",
  "foundations-assets": "static-1.5373",
  "foundations-theming": "static-1.4975",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12279",
  "icons": "static-2.704",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3369",
  "property-translator": "static-1.5865",
  "quartz-config": "static-1.1458",
  "quartz-core": "static-1.6899",
  "quartz-i18n": "static-1.1355",
  "quartz-routing": "static-1.1110",
  "quartz-tracking": "static-1.1059",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17223",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10855",
  "rpc-client-utils": "static-1.5154",
  "sanitize-text": "static-1.8643",
  "SharedI18nStrings": "static-1.188",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5244",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11630",
  "ui-images": "static-2.1278",
  "usage-tracker-core": "static-1.7658",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3957",
  "quartz-webpack": "static-1.3904",
  "bend-plugin-quartz-routing": "static-1.758",
  "bender-build-tools": "static-1.3600",
  "crm_universal": "static-1.22743",
  "customer-data-email": "static-1.18659",
  "customer-data-ui-utilities": "static-1.10317",
  "dispatcher": "static-1.148",
  "frontend-preferences-client": "static-1.8407",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8248",
  "quick-fetch": "static-1.4237",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5034",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2691",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9914",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3114",
  "ui-fonts": "static-1.1234",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3635",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "hs-locale-management": "static-1.408",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4791",
  "foundations-components-test-utils": "static-1.6248",
  "ui-addon-draggable": "static-3.5234",
  "commerce-billing-lib": "static-1.20514",
  "commerce-shared-components-lib": "static-1.19593",
  "commerce-tools-ui-lib": "static-1.11341",
  "crm-message-bus": "static-1.44133",
  "customer-data-objects-ui-components": "static-1.13521",
  "customer-data-properties": "static-1.53084",
  "growth-payments-core": "static-1.26523",
  "ui-addon-iframeable": "static-1.9562",
  "usage-tracker": "static-1.7808",
  "usage-tracker-container": "static-1.7798",
  "sassPrefix": "static-1.373",
  "inbound-db-properties-service-client": "static-1.4157",
  "foundations-theming-base": "static-1.3960",
  "bend-plugin-foundations-theming": "static-1.3458",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.276",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4981",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.651",
  "quartz-auth": "static-1.1355",
  "quartz-head": "static-1.1345",
  "quartz-test": "static-1.1355",
  "trellis-components": "static-1.3133",
  "usage-tracker-session-replay": "static-1.5494",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.185",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.564",
  "chirp-fetch": "static-1.2390",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4960",
  "FormUrlGenerator": "static-2.5199",
  "sequences-lib": "static-1.8804",
  "apollo-link-hub-http": "static-2.5074",
  "FileManagerCore": "static-1.40360",
  "FileManagerLib": "static-1.40501",
  "hubspot-apollo-client": "static-1.5368",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.743",
  "timezone-utils": "static-2.5716",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5095",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1498",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2972",
  "hs-resources": "static-1.671",
  "pulse": "static-1.1133",
  "utility-belt": "static-1.3023",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2034",
  "customer-data-associations": "static-1.7823",
  "customer-data-property-utils": "static-1.8537",
  "customer-data-tracking": "static-1.7357",
  "framework-data-schema-resolvers": "static-1.7378",
  "framework-data-table": "static-2.12857",
  "object-builder-ui-client": "static-1.50076",
  "payments-enrollment-embed-lib": "static-1.24235",
  "stripe-embedded-components": "static-1.8264",
  "ui-addon-opt": "static-4.8898",
  "ai-components-ui-library": "static-1.10042",
  "customer-data-rte": "static-1.33920",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24861",
  "growth-onboarding-confetti": "static-1.3543",
  "growth-onboarding-empty-states": "static-1.6549",
  "hubspot-prosemirror": "static-1.19302",
  "InboxConnectUtils": "static-4.15863",
  "payment-link-components": "static-1.24478",
  "payments-post-enroll-local-storage-lib": "static-1.5591",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39191",
  "react-colorpicker": "static-2.10695",
  "ui-addon-upgrades": "static-9.18552",
  "ui-addon-video-player": "static-1.9108",
  "user-context": "static-1.5539",
  "restore-request-side-panel-lib": "static-1.2047",
  "atom": "static-1.5557",
  "reference-resolvers": "static-1.8669",
  "calling-global-api": "static-1.66225",
  "calling-internal-common": "static-1.31810",
  "calling-lifecycle-internal": "static-1.67607",
  "calling-lifecycle-messages": "static-1.59899",
  "commerce-products-lib": "static-1.10938",
  "conditional-properties-service-client": "static-1.4119",
  "crm-index-visualization-core": "static-1.4773",
  "crm-links": "static-1.6798",
  "crm-pipelines-api-client-types": "static-1.4450",
  "customer-data-properties-shared-msw-handlers": "static-1.10249",
  "data-agent-utils": "static-1.949",
  "external-options-client-types": "static-1.4445",
  "formula-editor": "static-1.15024",
  "google-libphonenumber": "static-1.50",
  "inbound-db-meta-service-client": "static-1.3781",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1117",
  "multi-currency-client-types": "static-1.4014",
  "pipeline-validation-client-types": "static-1.4289",
  "property-value-citations": "static-1.3698",
  "reference-resolvers-lite": "static-1.8598",
  "smart-data-capture-core": "static-1.503",
  "smart-property-lib": "static-1.8681",
  "tiered-pricing": "static-1.2300",
  "topics-actions-lib": "static-1.669",
  "trellis-ext-i18n": "static-1.1404",
  "trial-components-library": "static-1.14400",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7632",
  "onboarding-scopes": "static-1.6939",
  "seat-types-lib": "static-1.1070",
  "magpie-lib": "static-1.5916",
  "navigation-messaging": "static-1.8519",
  "ts-schema": "static-1.4401",
  "opentelemetry-web": "static-1.23",
  "hub-http-shared-msw-handlers": "static-1.10922",
  "hubspotter-http-shared-msw-handlers": "static-1.10920",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8661",
  "audio-components": "static-1.6588",
  "breeze-artifacts-sdk": "static-1.1014",
  "ContentUtils": "static-1.69500",
  "copilot-toolkit": "static-1.12173",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30077",
  "FileManagerImages": "static-1.38012",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4627",
  "ui-universal-auth": "static-1.9764",
  "urlinator": "static-1.4999",
  "video-components": "static-1.14464",
  "video-data-lib": "static-1.36120",
  "video-embed": "static-1.36954",
  "hubspot-apollo-cache": "static-1.827",
  "trellis-migration-context": "static-1.66",
  "event-emitter": "static-1.1447",
  "fdsr-migration-layer": "static-1.497",
  "framework-builder-read-service-client": "static-1.4341",
  "bend-plugin-pulse": "static-1.636",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7283",
  "persist-promise": "static-1.4191",
  "customer-data-reference-ui-components": "static-1.13659",
  "reporting-data": "static-1.69388",
  "tasks-actions-lib": "static-1.455",
  "purchase-motions-components": "static-1.6645",
  "growth-onboarding-feedback-components": "static-1.7066",
  "growth-onboarding-reliability": "static-1.5569",
  "marketplace-ui-apps-core": "static-1.19582",
  "onboarding-tours": "static-1.17411",
  "stripe-connect-js": "static-1.83",
  "chatspot-core": "static-1.23946",
  "content-assistance-lib": "static-1.8438",
  "draft-content-plugins": "static-1.29174",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22376",
  "rich-text-lib": "static-1.20572",
  "breeze-engine-lib": "static-1.2225",
  "poll-commands": "static-1.3963",
  "video-components-external": "static-1.12462",
  "trellis-story-utils": "static-1.4983",
  "ui-addon-react-router-dom": "static-1.10010",
  "content-media-capture": "static-1.5817",
  "knowledge-content-types": "static-1.8765",
  "ui-addon-emoji-picker": "static-1.10348",
  "ui-business-units-lib": "static-1.9581",
  "ui-shepherd-react": "static-3.10765",
  "hub-http-contrib": "static-1.3518",
  "ui-addon-sales-email": "static-1.5687",
  "commerce-tours-lib": "static-1.6878",
  "getting-started-shared-tasks": "static-1.19585",
  "sales-checkout-service-client": "static-1.4006",
  "merchandise-lib": "static-1.286",
  "getting-started-shared-tasks-store": "static-1.18703",
  "onboarding-tours-utils": "static-1.1478",
  "calling-error-reporting": "static-1.31817",
  "shared-worker-versioning": "static-1.11529",
  "calling-usage-tracker": "static-1.7026",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2485",
  "commerce-permissions": "static-1.1271",
  "products-iframe-lib": "static-1.8935",
  "products-ui-components-shared-msw-handlers": "static-1.11304",
  "crm-index-associations-lib": "static-1.6933",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11005",
  "sales-views-client-types": "static-1.4744",
  "location-customization-utils-lib": "static-1.10442",
  "data-agent-kit": "static-1.936",
  "enrichment-settings-lib": "static-1.254",
  "fsm": "static-1.4243",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7289",
  "bark-lib": "static-1.17019",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6382",
  "react-codemirror": "static-1.11127",
  "data-agent-test-utils": "static-1.480",
  "data-token-picker": "static-1.17152",
  "react-tinymce": "static-1.56287",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11068",
  "tinymce-config": "static-2.55413",
  "tinymce-plugins": "static-1.58527",
  "embedded-academy-lib": "static-1.16038",
  "hubs-service-types": "static-1.1753",
  "navigation-components": "static-1.19192",
  "nest": "static-1.721",
  "nudge-client-utils": "static-1.3440",
  "purchase-motions-api": "static-1.6648",
  "signup-constants": "static-1.19963",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5376",
  "reactive-lib": "static-1.1206",
  "simple-logging-lib": "static-1.3536",
  "nav-meta": "static-1.30829",
  "breeze-engine-core": "static-1.1503",
  "cms-field-types": "static-1.5295",
  "content-icons-ui": "static-1.2467",
  "integrations-lib": "static-1.17454",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.328",
  "unified-auth-core-lib": "static-1.1560",
  "social-insights-client-types": "static-1.22950",
  "outpost": "static-1.4614",
  "reporting-client-types": "static-1.2845",
  "signup-ui-url-generator": "static-2.8523",
  "developer-experience-shared-components": "static-1.11026",
  "immutable-less": "static-1.5137",
  "marketplace-ui-client-types": "static-1.18457",
  "marketplace-ui-common": "static-1.21050",
  "ui-addon-integrations-directory-panel": "static-2.8438",
  "ui-extensibility-client-types": "static-1.4400",
  "growth-data-modal": "static-1.6150",
  "growth-onboarding-next-action-utils": "static-1.3006",
  "onboarding-tours-client": "static-1.5626",
  "ui-shepherd-tracker": "static-1.8146",
  "ui-coaching-tips": "static-1.29594",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1203",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19657",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4914",
  "calling-orchestration-schema": "static-1.37262",
  "crm-record-cards-service-types": "static-1.3871",
  "highcharts": "static-8.115",
  "storybook-react": "static-1.44",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16688",
  "browser-eslint": "static-2.57",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57383",
  "interframe": "static-3.5227",
  "tinymce-data": "static-1.41498",
  "layout-dnd-components": "static-1.13244",
  "layout-dnd-utils": "static-1.12219",
  "ui-brand-identity-lib": "static-1.16978",
  "academy-common-lib": "static-1.15499",
  "nudge-custom-function-registry": "static-1.3197",
  "nudge-renderer-utils": "static-1.3516",
  "whisper-core-api": "static-1.7659",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14869",
  "integrations-tracking-lib": "static-1.6108",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4622",
  "ai-settings-ui-library": "static-1.8611",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1605",
  "onboarding-data-sync-lib": "static-1.2855",
  "growth-onboarding-next-action-components": "static-1.3034",
  "user-context-client": "static-1.4995",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9374",
  "ContentData": "static-1.69575",
  "layout-data-lib": "static-1.10544",
  "academy-service-client": "static-1.4177",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4882",
  "trellis-ecosystem": "static-1.7867",
  "wootric-nps": "static-1.7304",
  "universal-page-editor-lib": "static-1.3498",
  "settings-ui-lib": "static-1.13013",
  "simple-data-table": "static-1.3843",
  "meetings-connect-utils-lib": "static-1.8105",
  "advanced-menus-core": "static-1.15834",
  "advanced-menus-lib": "static-1.12581",
  "ExportDialog": "static-6.10859",
  "ui-memberships-settings-lib": "static-1.35223",
  "crm-record-cards-client": "static-1.81",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15833",
  "simple-menus-lib": "static-1.17350"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28725",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2029",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.511",
  "crm_data": "/crm_data/static-4.93228",
  "data-fetching-client": "/data-fetching-client/static-1.10124",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8765",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1790",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6077",
  "hs-test-utils": "/hs-test-utils/static-1.8524",
  "hub-http": "/hub-http/static-1.6691",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11972",
  "I18n": "/I18n/static-7.1709",
  "jasmine-runner": "/jasmine-runner/static-1.6938",
  "quartz": "/quartz/static-1.7680",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.121",
  "react-utils": "/react-utils/static-2.5664",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.120",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6109",
  "UIComponents": "/UIComponents/static-3.8918",
  "usage-tracker-public": "/usage-tracker-public/static-1.7619",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38076",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.648",
  "cssUtils": "/cssUtils/static-1.1108",
  "customer-data-objects": "/customer-data-objects/static-1.8192",
  "FireAlarmUi": "/FireAlarmUi/static-1.4875",
  "foundations-assets": "/foundations-assets/static-1.5373",
  "foundations-theming": "/foundations-theming/static-1.4975",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12279",
  "icons": "/icons/static-2.704",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3369",
  "property-translator": "/property-translator/static-1.5865",
  "quartz-config": "/quartz-config/static-1.1458",
  "quartz-core": "/quartz-core/static-1.6899",
  "quartz-i18n": "/quartz-i18n/static-1.1355",
  "quartz-routing": "/quartz-routing/static-1.1110",
  "quartz-tracking": "/quartz-tracking/static-1.1059",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17223",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10855",
  "rpc-client-utils": "/rpc-client-utils/static-1.5154",
  "sanitize-text": "/sanitize-text/static-1.8643",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5244",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11630",
  "ui-images": "/ui-images/static-2.1278",
  "usage-tracker-core": "/usage-tracker-core/static-1.7658",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3957",
  "quartz-webpack": "/quartz-webpack/static-1.3904",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.758",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "crm_universal": "/crm_universal/static-1.22743",
  "customer-data-email": "/customer-data-email/static-1.18659",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10317",
  "dispatcher": "/dispatcher/static-1.148",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8407",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8248",
  "quick-fetch": "/quick-fetch/static-1.4237",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5034",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2691",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9914",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3114",
  "ui-fonts": "/ui-fonts/static-1.1234",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3635",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "hs-locale-management": "/hs-locale-management/static-1.408",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4791",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6248",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5234",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20514",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19593",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11341",
  "crm-message-bus": "/crm-message-bus/static-1.44133",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13521",
  "customer-data-properties": "/customer-data-properties/static-1.53084",
  "growth-payments-core": "/growth-payments-core/static-1.26523",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9562",
  "usage-tracker": "/usage-tracker/static-1.7808",
  "usage-tracker-container": "/usage-tracker-container/static-1.7798",
  "sassPrefix": "/sassPrefix/static-1.373",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4157",
  "foundations-theming-base": "/foundations-theming-base/static-1.3960",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3458",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.276",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4981",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.651",
  "quartz-auth": "/quartz-auth/static-1.1355",
  "quartz-head": "/quartz-head/static-1.1345",
  "quartz-test": "/quartz-test/static-1.1355",
  "trellis-components": "/trellis-components/static-1.3133",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5494",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.185",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.564",
  "chirp-fetch": "/chirp-fetch/static-1.2390",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4960",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5199",
  "sequences-lib": "/sequences-lib/static-1.8804",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5074",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5368",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.743",
  "timezone-utils": "/timezone-utils/static-2.5716",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5095",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1498",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2972",
  "hs-resources": "/hs-resources/static-1.671",
  "pulse": "/pulse/static-1.1133",
  "utility-belt": "/utility-belt/static-1.3023",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2034",
  "customer-data-associations": "/customer-data-associations/static-1.7823",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8537",
  "customer-data-tracking": "/customer-data-tracking/static-1.7357",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7378",
  "framework-data-table": "/framework-data-table/static-2.12857",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50076",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24235",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8264",
  "ui-addon-opt": "/ui-addon-opt/static-4.8898",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10042",
  "customer-data-rte": "/customer-data-rte/static-1.33920",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3543",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6549",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19302",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15863",
  "payment-link-components": "/payment-link-components/static-1.24478",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5591",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39191",
  "react-colorpicker": "/react-colorpicker/static-2.10695",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18552",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9108",
  "user-context": "/user-context/static-1.5539",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2047",
  "atom": "/atom/static-1.5557",
  "reference-resolvers": "/reference-resolvers/static-1.8669",
  "calling-global-api": "/calling-global-api/static-1.66225",
  "calling-internal-common": "/calling-internal-common/static-1.31810",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67607",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59899",
  "commerce-products-lib": "/commerce-products-lib/static-1.10938",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4119",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4773",
  "crm-links": "/crm-links/static-1.6798",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4450",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10249",
  "data-agent-utils": "/data-agent-utils/static-1.949",
  "external-options-client-types": "/external-options-client-types/static-1.4445",
  "formula-editor": "/formula-editor/static-1.15024",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3781",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1117",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4014",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4289",
  "property-value-citations": "/property-value-citations/static-1.3698",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8598",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.503",
  "smart-property-lib": "/smart-property-lib/static-1.8681",
  "tiered-pricing": "/tiered-pricing/static-1.2300",
  "topics-actions-lib": "/topics-actions-lib/static-1.669",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1404",
  "trial-components-library": "/trial-components-library/static-1.14400",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7632",
  "onboarding-scopes": "/onboarding-scopes/static-1.6939",
  "seat-types-lib": "/seat-types-lib/static-1.1070",
  "magpie-lib": "/magpie-lib/static-1.5916",
  "navigation-messaging": "/navigation-messaging/static-1.8519",
  "ts-schema": "/ts-schema/static-1.4401",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10922",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10920",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8661",
  "audio-components": "/audio-components/static-1.6588",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1014",
  "ContentUtils": "/ContentUtils/static-1.69500",
  "copilot-toolkit": "/copilot-toolkit/static-1.12173",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30077",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4627",
  "ui-universal-auth": "/ui-universal-auth/static-1.9764",
  "urlinator": "/urlinator/static-1.4999",
  "video-components": "/video-components/static-1.14464",
  "video-data-lib": "/video-data-lib/static-1.36120",
  "video-embed": "/video-embed/static-1.36954",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.827",
  "trellis-migration-context": "/trellis-migration-context/static-1.66",
  "event-emitter": "/event-emitter/static-1.1447",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.497",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4341",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.636",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7283",
  "persist-promise": "/persist-promise/static-1.4191",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13659",
  "reporting-data": "/reporting-data/static-1.69388",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.455",
  "purchase-motions-components": "/purchase-motions-components/static-1.6645",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7066",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5569",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "stripe-connect-js": "/stripe-connect-js/static-1.83",
  "chatspot-core": "/chatspot-core/static-1.23946",
  "content-assistance-lib": "/content-assistance-lib/static-1.8438",
  "draft-content-plugins": "/draft-content-plugins/static-1.29174",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22376",
  "rich-text-lib": "/rich-text-lib/static-1.20572",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2225",
  "poll-commands": "/poll-commands/static-1.3963",
  "video-components-external": "/video-components-external/static-1.12462",
  "trellis-story-utils": "/trellis-story-utils/static-1.4983",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10010",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "knowledge-content-types": "/knowledge-content-types/static-1.8765",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10348",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9581",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10765",
  "hub-http-contrib": "/hub-http-contrib/static-1.3518",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5687",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6878",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19585",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4006",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18703",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "calling-error-reporting": "/calling-error-reporting/static-1.31817",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11529",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7026",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2485",
  "commerce-permissions": "/commerce-permissions/static-1.1271",
  "products-iframe-lib": "/products-iframe-lib/static-1.8935",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11304",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6933",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11005",
  "sales-views-client-types": "/sales-views-client-types/static-1.4744",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10442",
  "data-agent-kit": "/data-agent-kit/static-1.936",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.254",
  "fsm": "/fsm/static-1.4243",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7289",
  "bark-lib": "/bark-lib/static-1.17019",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6382",
  "react-codemirror": "/react-codemirror/static-1.11127",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.480",
  "data-token-picker": "/data-token-picker/static-1.17152",
  "react-tinymce": "/react-tinymce/static-1.56287",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11068",
  "tinymce-config": "/tinymce-config/static-2.55413",
  "tinymce-plugins": "/tinymce-plugins/static-1.58527",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16038",
  "hubs-service-types": "/hubs-service-types/static-1.1753",
  "navigation-components": "/navigation-components/static-1.19192",
  "nest": "/nest/static-1.721",
  "nudge-client-utils": "/nudge-client-utils/static-1.3440",
  "purchase-motions-api": "/purchase-motions-api/static-1.6648",
  "signup-constants": "/signup-constants/static-1.19963",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5376",
  "reactive-lib": "/reactive-lib/static-1.1206",
  "simple-logging-lib": "/simple-logging-lib/static-1.3536",
  "nav-meta": "/nav-meta/static-1.30829",
  "breeze-engine-core": "/breeze-engine-core/static-1.1503",
  "cms-field-types": "/cms-field-types/static-1.5295",
  "content-icons-ui": "/content-icons-ui/static-1.2467",
  "integrations-lib": "/integrations-lib/static-1.17454",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.328",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1560",
  "social-insights-client-types": "/social-insights-client-types/static-1.22950",
  "outpost": "/outpost/static-1.4614",
  "reporting-client-types": "/reporting-client-types/static-1.2845",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8523",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11026",
  "immutable-less": "/immutable-less/static-1.5137",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8438",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4400",
  "growth-data-modal": "/growth-data-modal/static-1.6150",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3006",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8146",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29594",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1203",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19657",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4914",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37262",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "highcharts": "/highcharts/static-8.115",
  "storybook-react": "/storybook-react/static-1.44",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16688",
  "browser-eslint": "/browser-eslint/static-2.57",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57383",
  "interframe": "/interframe/static-3.5227",
  "tinymce-data": "/tinymce-data/static-1.41498",
  "layout-dnd-components": "/layout-dnd-components/static-1.13244",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12219",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16978",
  "academy-common-lib": "/academy-common-lib/static-1.15499",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3197",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3516",
  "whisper-core-api": "/whisper-core-api/static-1.7659",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14869",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6108",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4622",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8611",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1605",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2855",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3034",
  "user-context-client": "/user-context-client/static-1.4995",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9374",
  "ContentData": "/ContentData/static-1.69575",
  "layout-data-lib": "/layout-data-lib/static-1.10544",
  "academy-service-client": "/academy-service-client/static-1.4177",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4882",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7867",
  "wootric-nps": "/wootric-nps/static-1.7304",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3498",
  "settings-ui-lib": "/settings-ui-lib/static-1.13013",
  "simple-data-table": "/simple-data-table/static-1.3843",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8105",
  "advanced-menus-core": "/advanced-menus-core/static-1.15834",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12581",
  "ExportDialog": "/ExportDialog/static-6.10859",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35223",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.81",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15833",
  "simple-menus-lib": "/simple-menus-lib/static-1.17350"
}
};
